'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useCallback, useState } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { LanguageProvider } from './LanguageContext';
import { BrandProvider } from './BrandContext';
import { AuthUIProvider } from "better-auth-ui";
import { authClient } from './auth-client';

export function Providers({ children, brandName = 'ONEPAGE' }: { children: ReactNode; brandName?: string }) {
    const router = useRouter();
    const navigate = useCallback((href: string) => router.push(href), [router]);

    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        staleTime: 60 * 1000, // 1 minute
                        refetchOnWindowFocus: false,
                    },
                },
            })
    );

    return (
        <LanguageProvider>
            <BrandProvider value={brandName}>
            <AuthUIProvider
                authClient={authClient}
                basePath=""
                navigate={navigate}
                replace={navigate}
                Link={Link}
                credentials={{
                    forgotPassword: false,
                }}
                social={{
                    providers: [],
                }}
                genericOAuth={{
                    providers: [{ provider: "casdoor", name: "Casdoor" }],
                }}
            >
                <QueryClientProvider client={queryClient}>
                    {children}
                </QueryClientProvider>
            </AuthUIProvider>
            </BrandProvider>
        </LanguageProvider>
    );
}

